var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9",
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#3B4894"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6705 8.92049C15.1098 8.48116 15.1098 7.76884 14.6705 7.3295C14.2312 6.89017 13.5188 6.89017 13.0795 7.3295L9.375 11.034L7.9205 9.5795C7.48116 9.14016 6.76884 9.14016 6.3295 9.5795C5.89017 10.0188 5.89017 10.7312 6.3295 11.1705L8.5795 13.4205C9.01884 13.8598 9.73116 13.8598 10.1705 13.4205L14.6705 8.92049Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked1);
export default __webpack_public_path__ + "static/media/checked1.81bfdf71fad1bcbb4d303c75e0eaadd4.svg";
export { ForwardRef as ReactComponent };